export default {
  userInfo: {},
};




// WEBPACK FOOTER //
// ./src/store/home/state.js